import { I18n } from '@calendly/i18n'

import { buildNotification } from 'components/event_type_edit'

// i18n-tasks-use t("publisher.event_type_editor.sections.communications.timings.days")
// i18n-tasks-use t("publisher.event_type_editor.sections.communications.timings.hours")
// i18n-tasks-use t("publisher.event_type_editor.sections.communications.timings.minutes")
const getTimingUnit = ({ timing }) => {
  switch (timing.unit) {
    case 'days':
      return I18n.t('publisher.event_type_editor.sections.communications.timings.days', { count: timing.interval })
    case 'hours':
      return I18n.t('publisher.event_type_editor.sections.communications.timings.hours', { count: timing.interval })
    case 'minutes':
      return I18n.t('publisher.event_type_editor.sections.communications.timings.minutes', { count: timing.interval })
    default:
      return I18n.t('publisher.event_type_editor.sections.communications.timings.hours', { count: timing.interval })
  }
}

const formatTimingSubtitle = ({ timing, notificationName }) => {
  const amount = `${timing.interval} ${getTimingUnit({ timing })}`

  if (notificationName === 'invitee_email_follow_up') {
    return I18n.t(
      'publisher.event_type_editor.sections.more_options.notifications.card_copy.sends_after_meeting_ends',
      { amount }
    )
  }

  return I18n.t(
    'publisher.event_type_editor.sections.more_options.notifications.card_copy.sends_before_meeting_starts',
    { amount }
  )
}

export const crudSectionTitles = {
  emailReminder: () => I18n.t(
    'publisher.event_type_editor.sections.more_options.notifications.card_copy.email_reminder'
  ),
  textReminder: () => I18n.t(
    'publisher.event_type_editor.sections.more_options.notifications.card_copy.text_reminder'
  ),
  emailFollowUp: () => I18n.t(
    'publisher.event_type_editor.sections.more_options.notifications.card_copy.email_follow_up'
  )
}

export const getCrudConfirmationCardSubtitle = (htmlId) => {
  if (htmlId === 'invitation-cancellation') {
    return I18n.t('publisher.event_type_editor.sections.communications.invitation_cancellation.sends_immediately')
  }

  return I18n.t(
    'publisher.event_type_editor.sections.more_options.notifications.card_copy.sends_immediately_after_booking'
  )
}

export const getCrudTimingsSubtitle = ({ eventType, notificationName }) => {
  const timings = buildNotification(eventType, notificationName)?.timings || []

  if (!timings.length) return null

  return timings
    .map((timing) => formatTimingSubtitle({ timing, notificationName }))
    .join(', ')
}

export const getCrudTextReminderSubtitle = (isSmsDeactivated, eventType) => {
  if (isSmsDeactivated) {
    return I18n.t('publisher.event_type_editor.sections.communications.disabled_by_admin')
  }

  return getCrudTimingsSubtitle({ eventType, notificationName: 'invitee_sms_reminder' })
}
